module.exports = __webpack_public_path__ + "static/media/blue-jays-2024-dt-en.1e97afcc.jpg";